import { render } from "./ExecutionDetail.vue?vue&type=template&id=2ce67056&scoped=true"
import script from "./ExecutionDetail.vue?vue&type=script&lang=js"
export * from "./ExecutionDetail.vue?vue&type=script&lang=js"

import "./ExecutionDetail.vue?vue&type=style&index=0&id=2ce67056&scoped=true&lang=css"
import "./ExecutionDetail.vue?vue&type=style&index=1&id=2ce67056&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce67056"]])

export default __exports__